import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ShippingMethod, ShippingMethodClient, UserProfile, UserRoleTypes} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { ShippingMethodCreationComponent } from "./shipping-method-creation/shipping-method-creation.component";
import { ShippingMethodEditComponent } from "./shipping-method-edit/shipping-method-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { WtStorageService } from "../../../wt-storage.service";


@Component({
  selector: 'app-shipping-method',
  templateUrl: './shipping-method.component.html',
  styleUrls: ['./shipping-method.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ShippingMethodComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: ShippingMethod;
  public allObjects: ShippingMethod[];
  public searchQuery: string = '';
  public filteredObjects: ShippingMethod[] = [];
  public currentUser: UserProfile;

  constructor(private readonly changeDetectionRef: ChangeDetectorRef, private readonly localStorage: WtStorageService, private readonly modalService: NgbModal,public client:ShippingMethodClient){

    this.currentUser = this.localStorage.getuser();
  }

  ngOnInit(): void {

    this.loadData();

  }


    private loadData() {
        this.client.getList().subscribe((allObjects: ShippingMethod[]) => {
            this.isLoaded = false;
          this.allObjects = allObjects;
          this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
  }

  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.price.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) 
        
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

 public onSelected(object:ShippingMethod){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object:ShippingMethod):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(ShippingMethodCreationComponent, {});
  modalRef.componentInstance.onClose.subscribe(r => {
    this.loadData();
  });

}


public onDelete(): void {

    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.idShippingMethod).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(ShippingMethodEditComponent, { size: 'lg' });
    modalRef.componentInstance.editObject = this.selectedObject;
    modalRef.componentInstance.onClose.subscribe(r => {
      this.loadData();
    });

    }
    public getDate(item:Date):string{
      return DateHelper.GetFormattedDate(item);
  }


  public canSee(): boolean {

    return this.currentUser.userRole != UserRoleTypes.User
  }
}

